@if (form) {
  <form [formGroup]="form">
    <label>{{ 'ONBOARDING_CHANGE_EMAIL_LABEL' | translate }}</label>
    <em-input
      [label]="'ENTER_EMAIL_EMAIL_PLACEHOLDER' | translate"
      matInput
      type="email"
      formControlName="email"
      >
      <em-error>
        @if (form?.controls.email.hasError('validateEmail')) {
          {{ 'VALIDATION_EMAIL_PATTERN_WRONG' | translate }}
        }
        @if (form?.controls.email.hasError('required')) {
          {{ 'VALIDATION_FIELD_REQUIRED' | translate }}
        }
      </em-error>
    </em-input>
  </form>
}
